import { apiSlice } from "../";
import { getToken } from "shared/utils/getToken";

export interface DashboardResumoDTO {
  totalInscricoes: number;
  totalEstados: number;
  ultimaAtualizacao: string;
}

export interface DashboardInscricoesPorEstadoDTO {
  estado: string;
  quantidade: number;
}

export interface DashboardInscricoesPorGeneroDTO {
  genero: string;
  quantidade: number;
  percentual: number;
}

export interface DashboardInscricoesPorTipoGraduacaoDTO {
  tipoGraduacao: string;
  quantidade: number;
}

export interface DashboardTopCidadeDTO {
  cidade: string;
  estado: string;
  quantidade: number;
}

export interface DashboardInscricoesPorIdadeDTO {
  idade: number;
  quantidade: number;
}

export interface DashboardInscricoesPorDiaDTO {
  data: string;
  quantidade: number;
}

export interface DashboardInscricoesPorSemestreDTO {
  semestre: number;
  quantidade: number;
}

const dashboardSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDashboardResumo: builder.query<DashboardResumoDTO, number>({
      query: (idEdicao) => ({
        url: "dashboard/resumo",
        method: "GET",
        params: { edicao: idEdicao },
        headers: { Authorization: `Bearer ${getToken()}` },
      }),
    }),
    getDashboardInscricoesPorEstado: builder.query<DashboardInscricoesPorEstadoDTO[], number>({
      query: (idEdicao) => ({
        url: "dashboard/inscricoes-por-estado",
        method: "GET",
        params: { edicao: idEdicao },
        headers: { Authorization: `Bearer ${getToken()}` },
      }),
    }),
    getDashboardInscricoesPorGenero: builder.query<DashboardInscricoesPorGeneroDTO[], number>({
      query: (idEdicao) => ({
        url: "dashboard/inscricoes-por-genero",
        method: "GET",
        params: { edicao: idEdicao },
        headers: { Authorization: `Bearer ${getToken()}` },
      }),
    }),
    getDashboardInscricoesPorTipoGraduacao: builder.query<DashboardInscricoesPorTipoGraduacaoDTO[], number>({
      query: (idEdicao) => ({
        url: "dashboard/inscricoes-por-tipo-graduacao",
        method: "GET",
        params: { edicao: idEdicao },
        headers: { Authorization: `Bearer ${getToken()}` },
      }),
    }),
    getDashboardTopCidades: builder.query<DashboardTopCidadeDTO[], number>({
      query: (idEdicao) => ({
        url: "dashboard/top-10-inscricoes-por-cidade",
        method: "GET",
        params: { edicao: idEdicao, limite: 15 },
        headers: { Authorization: `Bearer ${getToken()}` },
      }),
    }),
    getDashboardInscricoesPorIdade: builder.query<DashboardInscricoesPorIdadeDTO[], number>({
      query: (idEdicao) => ({
        url: "dashboard/inscricoes-por-idade",
        method: "GET",
        params: { edicao: idEdicao },
        headers: { Authorization: `Bearer ${getToken()}` },
      }),
    }),
    getDashboardInscricoesPorDia: builder.query<DashboardInscricoesPorDiaDTO[], number>({
      query: (idEdicao) => ({
        url: "dashboard/inscricoes-por-dia",
        method: "GET",
        params: { edicao: idEdicao },
        headers: { Authorization: `Bearer ${getToken()}` },
      }),
    }),
    getDashboardInscricoesPorSemestre: builder.query<DashboardInscricoesPorSemestreDTO[], number>({
      query: (idEdicao) => ({
        url: "dashboard/inscricoes-por-semestre",
        method: "GET",
        params: { edicao: idEdicao },
        headers: { Authorization: `Bearer ${getToken()}` },
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetDashboardResumoQuery,
  useGetDashboardInscricoesPorEstadoQuery,
  useGetDashboardInscricoesPorGeneroQuery,
  useGetDashboardInscricoesPorTipoGraduacaoQuery,
  useGetDashboardTopCidadesQuery,
  useGetDashboardInscricoesPorIdadeQuery,
  useGetDashboardInscricoesPorDiaQuery,
  useGetDashboardInscricoesPorSemestreQuery,
} = dashboardSlice;
